import unitsDictionary from '@/shop/units-dictionary';

/**
 * @memberof Shop
 * @class
 * @alias Shop.units
 *
 * @description
 * Класс для работы с количественными типами товаров
 */
var Units = function(_owner) {
  var self = this;

  self._owner = _owner;

  self._init();
};

/**
 * Инициализация
 * @method
 *
 * @private
 */
Units.prototype._init = function() {
  var self = this;
};

/**
 * Получение наименования unit-а на основе специального обозначения unit из словаря с переводами
 * @method
 *
 * @param {string} Строка, unit - специального обозначения
 *
 * @return {string} Строка, с обычным обозначением для unit
 *
 * @example
 * Shop.units.format("kgm");
 */
Units.prototype.getName = function(unit) {
  var self = this;

  var unitName = '';
  var defaultLang = 'en';
  var lang = self._owner.config.config.locale;

  if (unitsDictionary[lang]) {
    unitName = unitsDictionary[lang][unit];
  } else {
    unitName = unitsDictionary[defaultLang][unit];
  }

  return (unitName) ? unitName : '';
};

export default Units;
